export default {
  method: "get",
  // 请求头信息
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 22000,
  // 携带凭证
  // withCredentials: false,
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
  retry: 4,
  retryDelay: 1000,
  showLoading: true,
  //是否在请求结束时保留loading（用于添加封面页定时轮训）
  banClearLoading: false
};
